<hs-content-condition-guard
  [guardedContent]="content"
  contentGuardCardHeader="No Account Loaded or Selected"
  contentGuardCardMessage="This panel requires either an account to be loaded or selected before
  information can be displayed. Please either load or select an account to continue."
  [conditionsMet$]="isAccountSelected"
>
</hs-content-condition-guard>
